"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _addingRecipients = require('./addingRecipients');



const COMPLETE = [_actionCreators2.default.campaignRecipientsAddCompleteNotificationAction.type]

/* P2' (Q3): when a background Add ends, its starter gets a notice wherever
 * they are in the app: what was added, or the stopped/failed wording as a
 * warning. Only the starter's connections get the push; the check on
 * StartedBy keeps it that way. Mounted once, inside the notice bar's
 * context. */
const RecipientsAddNotices = () => {
  const userKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const { showNoticeBar } = _noticeBar.useNoticeBar.call(void 0, )
  const onComplete = _react.useCallback.call(void 0, 
    (action) => {
      // SAFETY: registered for the complete notification's type only.
      const { Add, CampaignName } = (action ).payload
      if (!Add || (userKey && Add.StartedBy !== userKey)) return
      showNoticeBar(_addingRecipients.addFinishedNotice.call(void 0, Add, CampaignName))
    },
    [userKey, showNoticeBar],
  )
  _useBus2.default.call(void 0, COMPLETE, onComplete)
  return null
}

exports. default = _react.memo.call(void 0, RecipientsAddNotices)
